import { PackageCodes } from 'src/contexts/SubscriptionsContext';
import { ProgrammeActivityType } from 'src/resources/api/programme/types.api';

//
//

export type PackageCatalogEntry = {
  code: PackageCodes;
  name: string;
  description: string;
  highlights: { name: string }[];
  bestFor: string[];
  activityType: string | null;
};

//

export const PACKAGES_CATALOG: PackageCatalogEntry[] = [
  {
    code: PackageCodes.EVENT_OFFSETTING,
    activityType: ProgrammeActivityType.EVENT,
    name: 'Event',
    description: `Calculate and offset the carbon footprint of conferences, meetings, and corporate events — then tell that story to your clients and delegates.`,
    highlights: [
      { name: 'Event calculator (venue, travel, energy)' },
      { name: 'Offset certificates for you and your clients' },
      { name: 'Programme landing page with impact story' },
      { name: 'Delegate flight offset widget' },
    ],
    bestFor: ['Hotels', 'Event managers', 'Travel sellers', 'Corporates'],
  },
  {
    code: PackageCodes.BUSINESS_OFFSETTING,
    activityType: ProgrammeActivityType.BUSINESS,
    name: 'Business',
    description: `Measure and offset your Scope 1, 2, and 3 business emissions with annual reporting, certificates, and a public impact page.`,
    highlights: [
      { name: 'Business calculator (Scope 1, 2, 3)' },
      { name: 'Annual footprint reporting' },
    ],
    bestFor: ['SMEs', 'Corporates'],
  },
  {
    code: PackageCodes.TRAVEL_TOURS,
    activityType: ProgrammeActivityType.JOURNEY,
    name: 'Corporate Travel',
    description: `Bulk upload flight data, calculate itinerary footprints, and issue certificates to corporate clients — all from one portal.`,
    highlights: [
      { name: 'Bulk flight upload calculator' },
      { name: 'Corporate client certificates' },
      { name: 'Programme per client or tour' },
    ],
    bestFor: ['Travel agents', 'Tour operators'],
  },
  {
    code: PackageCodes.ACCOMMODATION_OFFSETTING,
    activityType: ProgrammeActivityType.JOURNEY,
    name: 'Accommodation',
    description: `Offer carbon-neutral room stays without PMS integration. Upload monthly room data and let guests offset their stay via a booking page widget.`,
    highlights: [
      { name: 'Guest offset widget for booking pages' },
      { name: 'No PMS integration needed' },
    ],
    bestFor: ['Hotels', 'Hotel chains', 'Hostels'],
  },
  {
    code: PackageCodes.AVIATION,
    activityType: ProgrammeActivityType.FLIGHT,
    name: 'Aviation',
    description: ``, // Not displayed yet, doesn't have a description.
    highlights: [],
    bestFor: [],
  },
];

export const getPackageByCode = (code: PackageCodes) => {
  return PACKAGES_CATALOG?.find((p) => p.code === code)?.name ?? 'Managed plan';
};
